import * as React from "react";
import { useState } from "react";
import HeaderBar from "./commons/components/HeaderBar";
import SettingPracticePage, { SettingPracticePageProps } from "./settings/SettingPracticePage";
import SettingsVirtualConsultationForm, {
  SettingsVirtualConsultationFormProps,
} from "./settings/SettingsVirtualConsultationForm";
import SettingsBranding, { SettingsBrandingProps } from "./SettingsBranding";
import { AvailableEntitiesSettings } from "./commons/model/EntitySettings";
import LoadingSpinner from "./flow/utils/LoadingSpinner";
import { createRoot } from "react-dom/client";

interface SettingsVirtualConsultationCustomisationProps {
  entities: AvailableEntitiesSettings;
  practicePageSetting?: SettingPracticePageProps;
  virtualConsultationSettings: SettingsVirtualConsultationFormProps;
  brandingSettings?: SettingsBrandingProps;
  isDsoEmployee: boolean;
}

const SettingsVirtualConsultationCustomisation = (
  props: SettingsVirtualConsultationCustomisationProps
) => {
  const [loading, setLoading] = useState(false);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="settings-customisation v-flex no-wrap full-height">
      <HeaderBar
        title={i18n["Page.Settings.VirtualConsultation.Customization.Title"]}
        entities={props.entities}
        onChange={() => {
          setLoading(true);
        }}
      />
      <div className="integration-container">
        {props.practicePageSetting && <SettingPracticePage {...props.practicePageSetting} />}
        {props.virtualConsultationSettings && (
          <SettingsVirtualConsultationForm
            settingsVirtualConsultationForm={props.virtualConsultationSettings}
            entities={props.entities}
            isDsoEmployee={props.isDsoEmployee}
          />
        )}
        {props.brandingSettings && (
          <SettingsBranding
            settingsBranding={props.brandingSettings}
            entities={props.entities}
            isDsoEmployee={props.isDsoEmployee}
          />
        )}
      </div>
    </div>
  );
};

export default SettingsVirtualConsultationCustomisation;

SettingsVirtualConsultationCustomisation.loadComponent = (
  elementId: string,
  props: SettingsVirtualConsultationCustomisationProps
) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<SettingsVirtualConsultationCustomisation {...props} />);
};
